export default "__VITE_ASSET__DpK3UReT__";